export function getPaginationUrl(pageNumber: number, queryString: string): string {
  if (/((^|&)p=)[^&]+/.test(queryString)) {
    return `/cat.php?${queryString.replace(/((^|&)p=)[^&]+/, `$1${pageNumber}`)}`;
  }

  return `/cat.php?${queryString}&p=${pageNumber}`;
}
